module.exports = __webpack_public_path__ + "static/img/4.b490cc41.png";